<template>
  <div class="page-wrapper" :class="{ 'viewport-page': !isDocsPage && $route.name !== 'home' }">
    <Header :class="addUniqueClass"/>
    <main :class="{'page-gradient': !isDocsPage, 'home-main': $route.name === 'home', 'docs-main': isDocsPage, 'play-main': $route.name === 'play', 'donate-main': $route.name === 'donate'}">
      <div id="background"></div>
      <router-view v-slot="{ Component }">
        <transition name="fadeLong" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import Footer from '@/components/Footer/Footer.vue'

export default {
  computed: {
    addUniqueClass () {
      return this.$route.meta.header
    },
    isDocsPage () {
      return this.$route.name === 'agreement' ||
              this.$route.name === 'privacy' ||
              this.$route.name === 'account-deletion' ||
              this.$route.name === 'contacts' ||
              this.$route.name === 'success' ||
              this.$route.name === 'recovery' ||
              this.$route.name === 'termsofuse';
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1 0 auto;
  margin-bottom: 0;
}
main.docs-main {
  height: auto;
  min-height: 0;
  overflow: visible;
}
.docs-main :deep(.content) {
  box-sizing: border-box;
  width: min(var(--footer-width), calc(100% - 32px));
  max-width: none;
  margin-inline: auto;
  padding-inline: 0;
  overflow-wrap: anywhere;
}
main.home-main {
  height: auto;
  /* Clip decorative layers at the viewport, beyond the centered home content. */
  overflow-x: clip;
}

@media (min-width: 1025px) and (min-height: 600px) {
  .viewport-page {
    height: 100svh;
    min-height: 0;
  }
  .viewport-page > main {
    flex: 1 1 0;
    height: 0;
    min-height: 0;
  }
  .viewport-page > footer {
    padding-block: 1rem;
  }
}
@media (max-width: 767px) {
  main.play-main { height: auto; min-height: 0; }
}
@media (max-width: 768px) {
  main.donate-main { height: auto; min-height: 0; padding-top: 0; }
}
</style>
